export default "__VITE_ASSET__4e4403ac__"